module.exports = __webpack_public_path__ + "media/images/icon__betPick--none@3x-0cc0cc5da81f637eff8d0f0f478227e4.png";